<template>
	<SoftButton :color="Color.TrueAArEII" class="flex items-center justify-between gap-2">
		<slot/>
		<i class="fa-solid fa-chevron-right"/>
	</SoftButton>
</template>
<script setup lang="ts">
import {Color} from '@/Types/Enums/Color'
import SoftButton from '@/Components/Buttons/SoftButton.vue'
</script>